import { render } from "./Tg-btn.vue?vue&type=template&id=6da7c9c0&scoped=true"
import script from "./Tg-btn.vue?vue&type=script&lang=js"
export * from "./Tg-btn.vue?vue&type=script&lang=js"

import "./Tg-btn.vue?vue&type=style&index=0&id=6da7c9c0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da7c9c0"]])

export default __exports__